(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gownlinkMobileCatNavInit) return;
    window.__gownlinkMobileCatNavInit = true;

    function activateTab(tab) {
      var nav = tab.closest('.mobile-cat-nav');
      if (!nav) return;

      nav.querySelectorAll('[data-cat-tab]').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      var targetId = tab.getAttribute('data-target');
      nav.querySelectorAll('.mobile-cat-nav__panel').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.id === targetId);
      });

      var panels = nav.querySelector('.mobile-cat-nav__panels');
      if (panels) panels.scrollTop = 0;
    }

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-cat-tab]');
      if (!tab) return;
      activateTab(tab);
    });

    document.addEventListener('keydown', function (event) {
      if (event.code !== 'Enter' && event.code !== 'Space') return;
      var tab = event.target.closest('[data-cat-tab]');
      if (!tab) return;
      event.preventDefault();
      activateTab(tab);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
